import logoSouschaif from '../assets/images/logo.png';
import logoMaisterchef from '../assets/images/logo_maisterchef.png';

const hostname = window.location.hostname || '';

export const isMaisterchef = hostname.includes('maisterchef');

export const brandName = isMaisterchef ? 'Maisterchef' : 'Souschaif';
export const brandNameChat = isMaisterchef ? 'MaisterChef' : 'SousChaif';
export const brandLogo = isMaisterchef ? logoMaisterchef : logoSouschaif;

const GERMAN_LANGUAGE_KEYS = new Set([
  'deutsch',
  'de',
  'de-de',
  'de-at',
  'de-ch',
  'german',
]);

export function isGermanLanguage(language) {
  if (!language) return false;
  const normalized = String(language).toLowerCase().trim();
  return GERMAN_LANGUAGE_KEYS.has(normalized) || normalized.startsWith('de-');
}

/** Editorial DE theme: only on Maisterchef hosts and only when UI language is German. */
export function isMaisterchefGermanTheme(language) {
  return isMaisterchef && isGermanLanguage(language);
}

export function mcDePageClass(language) {
  return isMaisterchefGermanTheme(language) ? 'mc-de-page' : '';
}

/**
 * Replace all occurrences of brand name variants in a string with the current brand name.
 * Handles: SousChaif, Souschaif, Sous-Chaif, sous-chaif, 'sous-chaif'
 */
export function brandify(text) {
  if (typeof text !== 'string') return text;
  return text
    .replace(/SousChaif/g, brandNameChat)
    .replace(/Souschaif/g, brandName)
    .replace(/Sous-Chaif/g, brandNameChat)
    .replace(/'sous-chaif'/g, brandNameChat)
    .replace(/sous-chaif/g, brandNameChat);
}
